import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";

export const useTableData = () => {
  const columns: (ColDef | ColGroupDef)[] = [
    {
      field: "Datetime",
      headerName: "DateTime",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.Datetime, "MM/dd - HH:mm:ss") || "",
    },
    {
      headerName: "Transaction",
      children: [
        {
          field: "TransactionType",
          headerName: "Type",
        },
        {
          field: "TransactionResult",
          headerName: "Result",
          type: "numericColumn",
        },
        {
          field: "TransactionMessage",
          headerName: "Message",
          minWidth: 200,
        },
      ],
    } as ColGroupDef,
    {
      field: "HeatNumber",
      headerName: "HeatNumber",
      type: "numericColumn",
    },
    {
      field: "BilletsGroup",
      headerName: "Billets Group",
      type: "numericColumn",
      minWidth: 150,
    },
    {
      headerName: "Origin Location",
      children: [
        {
          field: "OriginLocationName",
          headerName: "Name",
        },
        {
          field: "OriginLocationPosition",
          headerName: "Position",
          type: "numericColumn",
        },
        {
          field: "OriginLocationBillet",
          headerName: "Billet",
          type: "numericColumn",
        },
      ],
    } as ColGroupDef,
    {
      field: "BilletsMoved",
      headerName: "Billets Moved",
    },
    {
      headerName: "Destiny Location",
      children: [
        {
          field: "DestinyLocationName",
          headerName: "Name",
        },
        {
          field: "DestinyLocationPosition",
          headerName: "Position",
          type: "numericColumn",
        },
        {
          field: "DestinyLocationBillet",
          headerName: "Billet",
          type: "numericColumn",
        },
      ],
    } as ColGroupDef,
    {
      field: "Operator",
      headerName: "Operator",
    },
  ];

  return { columns };
};
